import styled from '@emotion/styled'

const CONTENT_COLOR = '#364a63'
const TIME_COLOR = '#8094ae'

const StyledFileDetail = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 4px;
  padding: 20px;
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    white-space: pre-line;
  }
`
const StyledFileLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 190px;
  width: 190px;
  cursor: pointer;
  .text {
    font-size: 14px;
    text-align: center;
    width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 20px;
  }
`
const StyledTime = styled.div`
  font-size: 12px;
  margin-top: 12px;
  color: ${TIME_COLOR};
`
const StyledContent = styled.div`
  color: ${CONTENT_COLOR};
  margin-bottom: 10px;
  width: 100%;
`
const StyledIconFile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 194px;
  cursor: pointer;
  .text {
    color: ${CONTENT_COLOR};
    width: 194px;
    text-align: center;
    font-size: 13px;
  }
`
const StyledContentHtml = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

export {
  StyledFileDetail,
  StyledFileLeft,
  StyledTime,
  StyledContent,
  StyledIconFile,
  StyledContentHtml,
}
